import { getParameterByName } from '@/utils/url'

export enum ParamStatus {
  OPEN = '1',
}

export const isLoop = () => {
  return getParameterByName('loop') === ParamStatus.OPEN
}
